import { fetchConToken } from "../helpers/fetch";
import { types } from "../types/types";
import { fetchDocumentacionStageAfiliacion } from "./documentaciones/documentacion";


export const seleccionFamiliarPreinscripto =  (idFamiliar)=> async (dispatch) => {

  const response = await fetchConToken(
    `Preafiliados/traerPorIdPreAfiliado/${idFamiliar}`
  );
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") !== -1) {
    const familiar = await response.json();
      delete familiar.id_tipo_afiliacion;
     dispatch({
       type:types.grupoFamiliarPreinscriptoSeleccion,
       payload:familiar
     });
  }
  dispatch(fetchDocumentacionStageAfiliacion(idFamiliar));
};

export const seleccionFamiliarPreinscriptoStage =  (idFamiliar)=> async (dispatch) => {

  const response = await fetchConToken(
    `Preafiliados/traerPorIdPreAfiliadoFamiliar/${idFamiliar}`
  );
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") !== -1) {
    const familiar = await response.json();
      delete familiar.id_tipo_afiliacion;
     dispatch({
       type:types.grupoFamiliarStagePreinscriptoSeleccion,
       payload:familiar
     });
  }
};


export const seleccionFamiliarAfiliado =  (idFamiliar)=> async (dispatch) => {

  const response = await fetchConToken(
    `Afiliados/traerPorIdAfiliado/${idFamiliar}`
  );
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") !== -1) {
    const familiar = await response.json();
      delete familiar.id_tipo_afiliacion;
     dispatch({
       type:types.familiarSeleccionadoAfiliado,
       payload:familiar
     });
  }
};


export const limpiarSeleccionFamiliar = () => {
  return async (dispatch) => {
   dispatch({
     type:types.grupoFamiliarLimpiarSeleccionado,
   });
  };
};


export const documentacionFamiliarPreafiliadoChange = (payload) => {
  return {
    type: types.documentacionFamiliarPreafiliadoChange,
    payload: payload,
  };
};

export const grupoFamiliarSetTab = (payload) => {
  return {
    type: types.grupoFamiliarSetTab,
    payload: payload,
  };
};